module.exports = __webpack_public_path__ + "img/male-avatar.9f643433.png";